export function guideBy(tester) {
    return function (target, key, descriptor) {
        console.log('log in decorators:', target, key, descriptor);
        const fn = descriptor.value;
        if (typeof fn === 'function') {
            descriptor.value = function (...args) {
                if (tester()) {
                    return fn.apply(this, args);
                }
                console.log('not pass the condition , return undefined');
                return undefined;
            };
        }
        return descriptor;
    };
}
